import * as React from 'react';
type Props = {
  className?: string;
};
export function Whoops({ className }: Props) {
  return (
    <svg
      viewBox="6 50 228 158"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Whoops"
      className={className}
    >
      <path
        d="M183.083 187.034C177.604 187.034 173.099 191.052 173.099 196.044C173.099 201.036 177.604 205.054 183.083 205.054C188.562 205.054 193.068 201.036 193.068 196.044C193.068 191.052 188.684 187.034 183.083 187.034ZM184.423 186.912C185.397 187.278 186.371 186.912 186.858 186.669C187.223 186.547 188.806 185.817 189.415 184.112C189.537 183.868 190.024 182.529 189.415 181.677C189.049 181.068 188.319 181.068 188.075 180.946C186.249 180.824 184.666 182.894 184.544 183.138C184.179 183.625 183.205 184.964 183.57 186.06C183.692 186.547 184.179 186.791 184.423 186.912Z"
        fill="white"
      />
      <path
        d="M228.499 177.293L205.365 184.355L208.774 206.028L232.882 205.054C232.882 205.054 235.074 192.148 228.499 177.293Z"
        fill="white"
      />
      <path
        d="M97 106.552L127.683 112.031L120.499 153.307L116.238 157.081L108.567 155.742L101.505 126.033L117.334 128.712C118.43 122.015 113.924 115.684 107.228 114.588C104.306 114.101 101.505 114.709 99.1916 116.049L97 106.552Z"
        fill="white"
      />
      <path
        d="M130.484 144.297L157.271 173.397L122.569 204.811L119.404 201.28L110.272 162.561L130.484 144.297ZM139.25 163.048C134.623 158.056 126.709 157.812 121.717 162.439L138.641 180.459C143.634 175.711 143.999 167.918 139.25 163.048Z"
        fill="white"
      />
      <path
        d="M175.656 176.563C177.726 180.459 178.213 184.721 177.482 188.617C174.925 190.2 173.221 193 173.221 196.044C173.221 196.409 173.221 196.775 173.343 197.14C171.882 198.845 170.055 200.306 167.985 201.402C158.853 206.15 147.652 202.863 142.903 193.974C141.929 192.148 141.32 190.2 140.955 188.252L157.392 173.397L152.765 168.283C161.288 164.874 171.273 168.283 175.656 176.563Z"
        fill="white"
      />
      <mask
        id="mask0_1305_1550"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={121}
        y={159}
        width={22}
        height={22}
      >
        <mask
          id="mask1_1305_1550"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={253}
          height={275}
        >
          <path d="M252.12 0.5H0.0800781V274.457H252.12V0.5Z" fill="white" />
        </mask>
        <g mask="url(#mask1_1305_1550)">
          <path
            d="M139.25 163.048C134.623 158.056 126.709 157.812 121.717 162.439L138.641 180.459C143.633 175.711 143.998 167.918 139.25 163.048Z"
            fill="white"
          />
        </g>
      </mask>
      <g mask="url(#mask0_1305_1550)">
        <path
          d="M148.747 153.063H115.75V186.547H148.747V153.063Z"
          fill="#FCFCFC"
        />
      </g>
      <mask
        id="mask2_1305_1550"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={97}
        y={106}
        width={31}
        height={52}
      >
        <mask
          id="mask3_1305_1550"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={253}
          height={275}
        >
          <path d="M252.12 0.5H0.0800781V274.457H252.12V0.5Z" fill="white" />
        </mask>
        <g mask="url(#mask3_1305_1550)">
          <path
            d="M97 106.552L108.811 156.229L115.873 157.203L120.865 153.307L127.561 112.153L97 106.552Z"
            fill="white"
          />
        </g>
      </mask>
      <g mask="url(#mask2_1305_1550)">
        <path
          d="M133.771 100.464H90.9121V163.291H133.771V100.464Z"
          fill="white"
        />
      </g>
      <path
        d="M130.484 144.297L157.271 173.397L122.569 204.811L119.404 201.28L110.272 162.561L130.484 144.297ZM139.25 163.048C134.623 158.056 126.709 157.812 121.717 162.439L138.641 180.459C143.634 175.711 143.999 167.918 139.25 163.048Z"
        fill="#CCE0F4"
      />
      <path
        d="M175.656 176.563C177.726 180.459 178.213 184.721 177.482 188.617C174.925 190.2 173.221 193 173.221 196.044C173.221 196.409 173.221 196.775 173.343 197.14C171.882 198.845 170.055 200.306 167.985 201.402C158.853 206.15 147.652 202.863 142.903 193.974C141.929 192.148 141.32 190.2 140.955 188.252L157.392 173.397L152.765 168.283C161.288 164.874 171.273 168.283 175.656 176.563Z"
        fill="#F6EEF8"
      />
      <path
        d="M183.083 187.034C177.604 187.034 173.099 191.052 173.099 196.044C173.099 201.036 177.604 205.054 183.083 205.054C188.562 205.054 193.068 201.036 193.068 196.044C193.068 191.052 188.684 187.034 183.083 187.034Z"
        fill="#F0CF9E"
      />
      <mask
        id="mask4_1305_1550"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={183}
        y={180}
        width={7}
        height={8}
      >
        <mask
          id="mask5_1305_1550"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={253}
          height={275}
        >
          <path d="M252.12 0.5H0.0800781V274.457H252.12V0.5Z" fill="white" />
        </mask>
        <g mask="url(#mask5_1305_1550)">
          <path
            d="M184.423 186.912C185.397 187.278 186.371 186.912 186.858 186.669C187.223 186.547 188.806 185.816 189.415 184.112C189.536 183.868 190.024 182.529 189.415 181.677C189.049 181.068 188.319 181.068 188.075 180.946C186.249 180.824 184.666 182.894 184.544 183.138C184.179 183.625 183.205 184.964 183.57 186.06C183.692 186.547 184.179 186.791 184.423 186.912Z"
            fill="white"
          />
        </g>
      </mask>
      <g mask="url(#mask4_1305_1550)">
        <path
          d="M195.746 174.858H177.36V193.122H195.746V174.858Z"
          fill="#FCFCFC"
        />
      </g>
      <mask
        id="mask6_1305_1550"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={183}
        y={180}
        width={7}
        height={8}
      >
        <mask
          id="mask7_1305_1550"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={253}
          height={275}
        >
          <path d="M252.12 0.5H0.0800781V274.457H252.12V0.5Z" fill="white" />
        </mask>
        <g mask="url(#mask7_1305_1550)">
          <path
            d="M184.423 186.912C185.397 187.278 186.371 186.912 186.858 186.669C187.223 186.547 188.806 185.816 189.415 184.112C189.536 183.868 190.024 182.529 189.415 181.677C189.049 181.068 188.319 181.068 188.075 180.946C186.249 180.824 184.666 182.894 184.544 183.138C184.179 183.625 183.205 184.964 183.57 186.06C183.692 186.547 184.179 186.791 184.423 186.912Z"
            fill="white"
          />
        </g>
      </mask>
      <g mask="url(#mask6_1305_1550)">
        <path
          d="M195.746 174.858H177.36V193.122H195.746V174.858Z"
          fill="#C2C918"
        />
      </g>
      <mask
        id="mask8_1305_1550"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={205}
        y={177}
        width={29}
        height={30}
      >
        <mask
          id="mask9_1305_1550"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={253}
          height={275}
        >
          <path d="M252.12 0.5H0.0800781V274.457H252.12V0.5Z" fill="white" />
        </mask>
        <g mask="url(#mask9_1305_1550)">
          <path
            d="M228.499 177.293L205.365 184.355L208.774 206.028L232.882 205.054C232.882 205.054 235.074 192.148 228.499 177.293Z"
            fill="white"
          />
        </g>
      </mask>
      <g mask="url(#mask8_1305_1550)">
        <path
          d="M239.336 171.206H199.277V212.116H239.336V171.206Z"
          fill="#FCFCFC"
        />
      </g>
      <path
        d="M228.499 177.293L205.365 184.355L208.774 206.028L232.882 205.054C232.882 205.054 235.074 192.148 228.499 177.293Z"
        fill="#EBF4EE"
      />
      <path
        d="M208.044 207.003L204.391 183.747L228.986 176.198L229.352 176.928C235.927 191.904 233.857 204.689 233.735 205.298L233.613 206.028L208.044 207.003ZM206.339 184.964L209.505 205.054L232.03 204.202C232.396 201.402 233.126 190.565 227.89 178.389L206.339 184.964Z"
        fill="currentColor"
      />
      <mask
        id="mask10_1305_1550"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={97}
        y={106}
        width={31}
        height={52}
      >
        <mask
          id="mask11_1305_1550"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={253}
          height={275}
        >
          <path d="M252.12 0.5H0.0800781V274.457H252.12V0.5Z" fill="white" />
        </mask>
        <g mask="url(#mask11_1305_1550)">
          <path
            d="M97 106.552L127.683 112.031L120.499 153.307L116.238 157.082L108.567 155.742L101.505 126.033L117.334 128.712C118.43 122.015 113.924 115.684 107.228 114.588C104.306 114.101 101.505 114.71 99.1916 116.049L97 106.552Z"
            fill="white"
          />
        </g>
      </mask>
      <g mask="url(#mask10_1305_1550)">
        <path
          d="M133.771 100.464H90.9121V163.291H133.771V100.464Z"
          fill="white"
        />
      </g>
      <path
        d="M97 106.552L127.683 112.031L120.499 153.307L116.238 157.081L108.567 155.742L101.505 126.033L117.334 128.712C118.43 122.015 113.924 115.684 107.228 114.588C104.306 114.101 101.505 114.709 99.1916 116.049L97 106.552Z"
        fill="#F7DBD2"
      />
      <path
        d="M111.245 205.541L75.3267 53.5868L83.8498 51.5169L119.769 203.472L111.245 205.541ZM77.0313 60.7705L109.784 198.966C109.541 199.088 109.176 199.088 108.81 199.21L38.7992 205.785C36.4857 206.028 34.1723 204.324 33.6853 202.132L7.26367 90.2361C6.77663 88.0444 8.11598 85.4875 10.3076 84.757L76.179 61.014C76.4225 60.8923 76.7878 60.8923 77.0313 60.7705Z"
        fill="#F8F6F2"
      />
      <path
        d="M187.832 187.156C188.928 186.547 189.78 185.573 190.267 184.477C190.876 182.773 190.633 181.798 190.145 181.19C189.658 180.581 189.05 180.216 188.197 180.094C186.371 179.972 184.91 181.311 184.058 182.286V178.146H182.231V186.182C181.014 186.304 179.796 186.547 178.578 187.034C178.944 183.26 178.213 179.485 176.387 176.076C171.882 167.674 161.776 163.9 152.766 167.066L130.484 142.836L121.717 150.75L128.536 111.3L97.609 105.699L84.5808 50.421L74.2313 52.8562L75.936 60.0399H75.8142L9.94284 83.9046C7.38591 84.8787 5.6813 87.8009 6.41185 90.4796L32.8334 202.376C33.4422 204.933 35.8774 206.759 38.4343 206.759C38.5561 206.759 38.7996 206.759 38.9214 206.759L108.933 200.184H109.054L110.637 206.637L120.743 204.202L122.448 206.028L140.224 189.956C140.59 191.539 141.199 193 141.929 194.34C145.338 200.793 152.035 204.446 158.975 204.446C162.141 204.446 165.307 203.715 168.229 202.132C169.812 201.28 171.395 200.184 172.612 198.966C173.952 202.984 178.091 205.907 182.962 205.907C188.928 205.907 193.798 201.402 193.798 196.044C194.042 192.148 191.485 188.739 187.832 187.156ZM185.275 183.747C186.006 182.773 187.102 181.798 188.076 181.92C188.319 181.92 188.563 182.042 188.684 182.164C188.806 182.286 188.928 182.773 188.563 183.747C188.076 184.964 187.102 185.451 186.493 185.695C186.127 185.817 185.397 186.182 184.788 185.938C184.545 185.817 184.423 185.817 184.301 185.573C184.301 185.573 184.301 184.964 185.275 183.747ZM126.588 112.883L119.647 152.942L115.873 156.351L109.298 155.133L102.723 127.372L118.064 129.929L118.186 129.077C119.282 121.893 114.412 115.075 107.35 113.857C104.793 113.37 102.114 113.735 99.8006 114.831L98.096 107.648L126.588 112.883ZM114.168 157.812L110.759 160.978L109.785 157.082L114.168 157.812ZM102.358 125.303L100.288 116.658C102.479 115.562 104.793 115.197 107.106 115.562C112.951 116.536 117.09 121.893 116.603 127.738L102.358 125.303ZM38.7996 204.933C36.9733 205.054 35.0251 203.715 34.6598 201.889L8.11646 89.9925C7.75119 88.1662 8.84701 86.218 10.5516 85.4875L76.423 61.7446L108.689 198.358L38.7996 204.933ZM118.795 202.863L111.976 204.446L110.881 199.697L76.423 54.1955L83.2415 52.6127L95.7826 105.334L98.7048 117.51L100.409 124.937L107.837 156.594L109.176 162.195L118.43 201.402V201.645L118.795 202.863ZM139.859 187.886L122.569 203.472L120.134 200.793L111.124 162.926L116.36 158.177H116.482L121.23 153.794V153.672L130.362 145.393L155.931 173.154L139.859 187.886ZM173.465 191.539C173.465 191.661 173.343 191.661 173.343 191.783C173.221 192.026 173.099 192.27 172.978 192.513C172.978 192.635 172.856 192.757 172.856 192.879C172.734 193.122 172.734 193.366 172.612 193.609C172.612 193.731 172.49 193.853 172.49 193.974C172.49 194.218 172.369 194.461 172.369 194.705C172.369 194.827 172.369 194.948 172.369 195.07C172.369 195.435 172.247 195.801 172.247 196.166C172.247 196.41 172.247 196.653 172.247 196.897C170.908 198.358 169.203 199.697 167.377 200.671C158.732 205.298 148.017 202.132 143.512 193.609C142.66 192.026 142.051 190.322 141.807 188.617L158.488 173.397L154.105 168.649C162.141 166.213 170.786 169.623 174.804 177.05C176.63 180.459 177.239 184.355 176.509 188.13C176.387 188.252 176.387 188.252 176.265 188.373C176.021 188.495 175.9 188.617 175.656 188.86C175.534 188.982 175.413 189.104 175.291 189.226C175.169 189.348 175.047 189.469 174.926 189.591C174.804 189.713 174.682 189.835 174.56 189.956C174.439 190.078 174.317 190.2 174.195 190.443C174.073 190.565 173.952 190.687 173.952 190.809C173.83 191.052 173.586 191.296 173.465 191.539ZM183.083 204.202C178.457 204.202 174.56 201.036 174.073 197.018C174.073 196.775 174.073 196.41 174.073 196.166C174.073 195.922 174.073 195.557 174.195 195.314C174.195 195.192 174.195 195.192 174.195 195.07C174.195 194.827 174.317 194.583 174.317 194.461C174.317 194.34 174.317 194.34 174.439 194.218C174.56 193.974 174.56 193.731 174.682 193.487V193.366C174.804 193.122 174.926 192.757 175.047 192.513C175.047 192.513 175.047 192.391 175.169 192.391C175.291 192.148 175.413 192.026 175.534 191.783C175.656 191.661 175.656 191.661 175.778 191.539C175.9 191.417 176.021 191.174 176.143 191.052C176.265 190.93 176.265 190.93 176.387 190.809C176.63 190.565 176.752 190.443 176.996 190.2C177.117 190.078 177.117 190.078 177.239 189.956C177.361 189.835 177.604 189.713 177.726 189.591C178.944 188.739 180.527 188.252 182.109 188.008V189.835H183.936V188.008C188.441 188.373 192.094 191.904 192.094 196.044C192.215 200.549 188.076 204.202 183.083 204.202Z"
        fill="#2B344F"
      />
      <path
        d="M188.197 197.018H186.371V198.723H188.197V197.018Z"
        fill="#2B344F"
      />
      <path
        d="M184.788 193.853H182.962V195.679H184.788V193.853Z"
        fill="#2B344F"
      />
      <path
        d="M189.415 192.513H187.588V194.34H189.415V192.513Z"
        fill="#2B344F"
      />
      <path
        d="M139.981 162.439C134.989 157.082 126.587 156.838 121.23 161.83L120.5 162.439L138.642 181.677L139.25 181.068C141.807 178.633 143.39 175.345 143.512 171.814C143.634 168.283 142.416 164.996 139.981 162.439ZM138.763 179.12L123.178 162.561C127.805 158.908 134.624 159.395 138.642 163.656C140.711 165.848 141.807 168.77 141.686 171.814C141.564 174.493 140.59 177.05 138.763 179.12Z"
        fill="#2B344F"
      />
      <path
        d="M39.4084 162.561C36.608 163.169 33.8075 161.708 33.1987 159.151C32.5899 156.594 34.4163 153.916 37.2167 153.307L75.6924 144.175C78.4929 143.566 81.2934 145.027 81.9021 147.584C82.5109 150.141 80.6845 152.82 77.8841 153.429L39.4084 162.561Z"
        fill="white"
      />
      <path
        d="M38.069 163.656C35.2685 163.656 32.8333 161.952 32.2245 159.395C31.8593 157.934 32.2246 156.351 33.0769 155.012C33.9292 153.672 35.2685 152.82 36.8514 152.455L75.3271 143.323C76.91 142.957 78.4928 143.201 79.9539 143.931C81.415 144.662 82.3891 146.001 82.6326 147.462C83.3632 150.506 81.2932 153.672 77.884 154.403L39.4083 163.535C39.1648 163.535 38.6778 163.656 38.069 163.656ZM77.0317 144.906C76.6664 144.906 76.3012 144.906 75.9359 145.027L37.4602 154.159C36.3643 154.403 35.3903 155.133 34.6597 155.986C34.0509 156.838 33.8074 157.934 34.0509 158.908C34.5379 160.978 36.8514 162.195 39.1648 161.708L77.6405 152.576C79.9539 151.968 81.415 149.898 80.928 147.828C80.6844 146.854 80.0756 146.001 79.1016 145.514C78.4928 145.027 77.7623 144.906 77.0317 144.906Z"
        fill="currentColor"
      />
      <mask
        id="mask12_1305_1550"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={21}
        y={93}
        width={50}
        height={19}
      >
        <mask
          id="mask13_1305_1550"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={253}
          height={275}
        >
          <path d="M252.12 0.5H0.0800781V274.457H252.12V0.5Z" fill="white" />
        </mask>
        <g mask="url(#mask13_1305_1550)">
          <path
            d="M27.4756 111.787C24.6751 112.396 21.8746 110.935 21.2659 108.378C20.6571 105.821 22.4835 103.142 25.2839 102.534L63.7596 93.4018C66.5601 92.793 69.3605 94.2541 69.9693 96.811C70.5781 99.3679 68.7517 102.047 65.9513 102.655L27.4756 111.787Z"
            fill="white"
          />
        </g>
      </mask>
      <g mask="url(#mask12_1305_1550)">
        <path
          d="M76.1789 87.0703H15.0562V117.997H76.1789V87.0703Z"
          fill="#FCFCFC"
        />
      </g>
      <path
        d="M27.4758 111.787C24.6753 112.396 21.8749 110.935 21.2661 108.378C20.6573 105.821 22.4837 103.142 25.2842 102.534L63.7599 93.4018C66.5603 92.793 69.3607 94.2541 69.9695 96.811C70.5783 99.3679 68.752 102.047 65.9515 102.655L27.4758 111.787Z"
        stroke="#2B344F"
        strokeWidth={1.5}
        strokeMiterlimit={10}
      />
      <path
        d="M32.1026 138.209C29.3022 138.209 26.867 136.504 26.2582 133.947C25.5276 130.903 27.5975 127.738 31.0067 127.007L69.4825 117.875C72.7699 117.145 76.0574 118.971 76.788 122.015C77.5185 125.059 75.4486 128.225 72.0394 128.955L33.5637 138.087C33.1984 138.209 32.5896 138.209 32.1026 138.209ZM71.0653 119.458C70.7001 119.458 70.3348 119.458 69.9695 119.58L31.4938 128.712C29.1804 129.321 27.7193 131.39 28.2063 133.46C28.6933 135.53 31.0068 136.748 33.3202 136.261L71.7959 127.129C74.1093 126.52 75.5704 124.45 75.0834 122.38C74.5963 120.676 72.8917 119.458 71.0653 119.458Z"
        fill="#2B344F"
      />
      <path
        d="M45.4963 187.886C42.6959 188.495 39.8954 187.034 39.2866 184.477C38.6778 181.92 40.5042 179.242 43.3046 178.633L81.7803 169.501C84.5808 168.892 87.3812 170.353 87.99 172.91C88.5988 175.467 86.7724 178.146 83.972 178.754L45.4963 187.886Z"
        fill="white"
      />
      <path
        d="M44.1569 188.982C41.3564 188.982 38.9212 187.278 38.3124 184.721C37.9472 183.26 38.3124 181.677 39.1648 180.337C40.0171 178.998 41.3564 178.146 42.9393 177.78L81.415 168.649C82.9978 168.283 84.5807 168.527 86.0418 169.257C87.5029 169.988 88.477 171.327 88.7205 172.788C89.451 175.832 87.3811 178.998 83.9719 179.729L45.4962 188.86C45.1309 188.86 44.6439 188.982 44.1569 188.982ZM82.9978 170.231C82.6326 170.231 82.2673 170.231 81.902 170.353L43.4263 179.485C42.3305 179.729 41.3564 180.459 40.6259 181.311C40.0171 182.164 39.7736 183.26 40.0171 184.234C40.5041 186.304 42.8175 187.521 45.1309 187.034L83.6066 177.902C85.92 177.293 87.3812 175.223 86.8941 173.154C86.6506 172.18 86.0418 171.327 85.0677 170.84C84.5807 170.475 83.7284 170.231 82.9978 170.231Z"
        fill="#2B344F"
      />
    </svg>
  );
}
